import React, { Fragment, useState, useEffect } from "react";
import { translate } from "../../../Services/translation";
import { getDistanceFromLatLonInKm, getAddressCombinedString, filterStoresBasedOnInput } from '../../../Services/StoreService';
import { get } from '../../../Services/http';
import { boldSubstr } from "../../QuickSearchResult";

export const NearestOptician = (props) => {
    const [stores, setstores] = useState([]);
    const [showStoresList, setshowStoresList] = useState(false);
    const [filteredStores, setfilteredStores] = useState([]);
    const [noresults, setnoresults] = useState(false);
    const [selectedStoreName, setSelectedStoreName] = useState("");
    const [searchTerm, setsearchTerm] = useState("");
    const [firstFiveStores, setfirstFiveStores] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        (() => {
            navigator.geolocation.getCurrentPosition((position) => {
                get(`/api/stores/GetNearestStores`)
                    .then((response) => response.json())
                    .then((result) => {
                        setLoading(false);
                        if (position.coords && position.coords.latitude && position.coords.longitude) {
                            let nearestStores = [];
                            result.forEach((store) => {
                                nearestStores.push({
                                    item: store,
                                    distance: getDistanceFromLatLonInKm(store.storeCoordLat, store.storeCoordLong, position.coords.latitude, position.coords.longitude),
                                });
                            });
                            const sortedResults = nearestStores.sort((a, b) => a.distance - b.distance);
                            const items = sortedResults.map(x => x.item);
                            setstores(items);
                            setfilteredStores(items);
                        } else {
                            const sortedResults = result.sort((a, b) => a.storeName.localeCompare(b.storeName));
                            setstores(sortedResults);
                            setfilteredStores(sortedResults);
                        }                        
                    })
            });

            if (stores.length === 0) {
                get(`/api/stores/GetNearestStores`)
                    .then((response) => response.json())
                    .then((result) => {
                        const sortedResults = result.sort((a, b) => a.storeName.localeCompare(b.storeName));
                        setstores(sortedResults);
                        setfilteredStores(sortedResults);
                    });
            }
        })();
    }, []);

    useEffect(() => {
        if (stores.length > 0) {
            if (props.selectedStoreId) {
                let storesList = [];
                for(var i = 0; i < 4; i++) {
                    storesList.push(stores.filter(x => x.storeId !== props.selectedStoreId)[i]);
                }
                storesList.push(stores.filter(x => x.storeId === props.selectedStoreId)[0]);                
                setfirstFiveStores(storesList);
            } else {
                setfirstFiveStores(stores.slice(0, 5));
            }  
        }              
    }, [stores, selectedStoreName]);


    const filterStores = (input) => {        
        setsearchTerm(input);
        const storesFiltered = filterStoresBasedOnInput(stores, input);

        if (storesFiltered && storesFiltered.length > 0) {
            setshowStoresList(true);
            setfilteredStores(storesFiltered);
            setnoresults(false);
        } else {
            setshowStoresList(false);
            setfilteredStores([]);
            setnoresults(true);
        }
    }    
    
    const onClose = () => {
        setshowStoresList(false);
    }

    return (
        <Fragment>
            <div>
                <div className="column small-12 register__nearest-opt-description">
                    {translate('coptikk.register.nearestopticiandescription')}
                </div>
            </div>            
            <div>
                {loading && 
                    <div className="column small-12 register__loading">
                        <div className="loading-spinner"></div>
                    </div>
                }
                <div className="column small-12">
                    {firstFiveStores.map(item => {
                        return <div className="register__storesearch">
                            <div className="register__storesearch-column mydetails-panel__results-item" key={item.storeId}>
                                <div>{item.storeName}</div>
                                <div>{item.storeAddress}, {item.storeCity}</div>
                            </div>
                            <div className="register__storesearch-column">
                                <a className={`button ${item.storeId === props.selectedStoreId ? ' secondary' : ''}`} onClick={() => {
                                    props.setSelectedStoreId(item.storeId);
                                    setshowStoresList();
                                    setSelectedStoreName(stores.filter(a => a.storeId === item.storeId)[0].storeName);
                                }}>{item.storeId === props.selectedStoreId ? translate('coptikk.general.selected') : translate('coptikk.general.select')}</a>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div>
                <div className="columns small-12 register__search-input-column">
                    <input type="text" className="register__searchinput" placeholder={translate('coptikk.register.searchstore')} 
                    value={searchTerm}
                        onChange={e => filterStores(e.target.value)}>                            
                        </input>
                    {searchTerm && <i className="register__search-icon-close" onClick={() => {                        
                            setsearchTerm(""); 
                            setfilteredStores(stores);
                        }}></i>}
                    <i className="register__search-icon"></i>
                    {showStoresList && !noresults && <div className="mydetails-panel__results register__search-result-list">
                        <div className="register__search-close-wrapper">
                            <i className="close" onClick={onClose}></i>
                        </div>
                        {filteredStores.map(x => {
                            return <div key={x.storeId} className="register__storesearch">
                                <div className="register__storesearch-column mydetails-panel__results-item">
                                    <div dangerouslySetInnerHTML={{ __html: searchTerm ? boldSubstr(x.storeName, searchTerm) : x.storeName }}></div>
                                    <div dangerouslySetInnerHTML={{
                                        __html: searchTerm ? boldSubstr((getAddressCombinedString(x)), searchTerm) :
                                            getAddressCombinedString(x)
                                    }}>
                                    </div>
                                </div>
                                <div className="register__storesearch-column">
                                    <a className={`button ${x.storeId === props.selectedStoreId ? ' secondary' : ''}`} onClick={() => {
                                        props.setSelectedStoreId(x.storeId);
                                        setshowStoresList();
                                        setSelectedStoreName(stores.filter(a => a.storeId === x.storeId)[0].storeName);
                                        setsearchTerm('');
                                    }}>{x.storeId === props.selectedStoreId ? translate('coptikk.general.selected') : translate('coptikk.general.select')}</a>
                                </div>
                            </div>
                        })}
                        {noresults && <div>{translate('coptikk.mypages.searchnoresults')}</div>}
                    </div>}
                </div>
            </div>
        </Fragment>
    )
}